export default __webpack_public_path__ + "static/media/wipro.0780f2ba.svg";